<template>
    <!-- CTA Section -->
    <section class="py-20 bg-secondary-500 text-white">
        <div class="max-w-2xl mx-auto text-center px-4 sm:px-6 lg:px-8">
            <h2 class="text-4xl font-headings mb-6">Rather talk to someone first?</h2>
            <p class="text-xl mb-8 opacity-90">
                Join thousands of event organizers who trust <img src="@/images/entegy-logo-white.svg" alt="Entegy Logo"
                    class="h-7 inline-block"> to deliver exceptional experiences.
            </p>
            <div class="flex flex-col sm:flex-row gap-4 justify-center">
                <a href='/contact'>
                    <Button text="Talk to the team" variant="accent" hasArrow size="md" />
                </a>
            </div>
        </div>
    </section>
</template>

<script setup>
import Button from '@/components/Buttons/Button.vue'
</script>